import { default as commandRibbonStore } from '../store/store';

export function getRibbonViewMode() {
    return commandRibbonStore.viewMode;
}
